import { FileInfo } from "./file";
import { Organization } from "./organization";
import { UserInfo } from "./user";

export enum RegisterStatus {
  Submit = 1,
  Success = 2,
  Failed = 3,
  Draft = 4,
}

export enum IdCardType {
  Resident = 1,
  Permit = 2,
  Passport = 3,
}

export interface PlayerRealname {
  name: string;
  idCardType: IdCardType;
  idNumber: string;
  register?: Register;
}

export interface UnitRealname {
  name: string;
  shortName: string;
  regionId: number;
  evidences: FileInfo[];
  register?: Register;
}

export interface Register {
  id: number;
  createdAt: string;
  updatedAt: string;
  organizationId: number;
  organization: Organization;
  status: RegisterStatus;
  playerRealname?: PlayerRealname;
  unitRealname?: UnitRealname;
  histories: any[];
  userId: number;
  user?: UserInfo;
}
